import { configureStore } from '@reduxjs/toolkit';
import { API } from '../services';
import APIErrorHandler from '../services/errorHandler';
import rootReducer from './rootReducer';

const store = configureStore({
  reducer: {
    [API.reducerPath]: API.reducer,
    ...rootReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
    .concat(API.middleware)
    .concat(APIErrorHandler),
});

export default store;
